const share = {
  profile: 'Profil',
  share: 'Partager',
  scan: 'Scanner',
  publish: 'Publier',
}


export default share
